module.exports = __webpack_public_path__ + "img/emergency-siren.1ce3c020.svg";